module.exports = __webpack_public_path__ + "img/illustration-130323-raw.280a8ff1.jpeg";